import { Component, OnInit, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatSnackBar
} from '@angular/material';
import { LocalUserService } from '../../../../shared/services/localUser';
import { UserService } from '../../../../shared/services/user.service';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { Role } from '../../../../shared/models/role';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { PlaidService } from '../../../../shared/services/plaid.service';
import { StripePaymentService } from '../../../../shared/services/stripePayment.service';

@Component({
  selector: 'app-ach-micro-deposit-verify',
  templateUrl: './ach-micro-deposit-verify.component.html',
  styleUrls: ['./ach-micro-deposit-verify.component.scss'],
  providers: [LocalUserService, PlaidService]
})
export class AchMicroDepositVerifyComponent implements OnInit {
  userData: any;
  token: string;
  userID: string;
  organizationId: string;
  userRole: string;
  stripeAchVerifyMicroDepositForm: FormGroup;
  loading: boolean;
  stripeAchVerifyMicroDepositFormErrors = [];
  caseData: any;
  plaidCustomerId: any;
  constructor(
    public dialogRef: MatDialogRef<AchMicroDepositVerifyComponent>,
    public dialog: MatDialog,
    private userService: UserService,
    private localUser: LocalUserService,
    public snackBar: MatSnackBar,
    public fb: FormBuilder,
    public router: Router,
    private plaidService: PlaidService,
    private stripePayment: StripePaymentService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  ngOnInit() {
    let userSaved = this.localUser.getUser();
    this.plaidCustomerId =
      userSaved && userSaved.paymentPref
        ? userSaved.paymentPref.plaidCustomerId
        : null;
    this.stripeAchVerifyMicroDepositForm = new FormGroup({
      first_number: new FormControl(''),
      second_number: new FormControl('')
    });
    this.userID = this.localUser.getUserId();
    this.userRole = this.localUser.getRole();
    this.organizationId = this.localUser.getOrganizationId();
  }
  microdepositVerifySubmit() {
    this.stripeAchVerifyMicroDepositFormErrors = [];
    let firstAmount = parseFloat(this.stripeAchVerifyMicroDepositForm.value.first_number);
    let secondAmount = parseFloat(this.stripeAchVerifyMicroDepositForm.value.second_number);
    if (Number.isNaN(firstAmount)) {
      this.stripeAchVerifyMicroDepositFormErrors.push('Please enter correct first amount');
    }
    if (Number.isNaN(secondAmount)) {
      this.stripeAchVerifyMicroDepositFormErrors.push('Please enter correct second amount');
    }
    if (!Number.isNaN(firstAmount) && !Number.isNaN(secondAmount)) {
      this.loading = true;
      let microDepositVerifyObj = {
        customer_id: this.plaidCustomerId,
        user_id: this.userID,
        organization_id: this.organizationId,
        microDepositAmounts: '' + firstAmount + ',' + secondAmount + ''
      };
      this.stripePayment.postStripeAchMicroDepositVerify(microDepositVerifyObj).subscribe(
        resultACH => {
          this.loading = false;
          console.log('ACH micro-deposit verify postPlaid result', resultACH);
          this.loading = false;
          let successMsg = 'Your account has been verified successfully.';
          this.snackBar.open(successMsg, null, {
            extraClasses: ['success-snackbar'],
            duration: 5000
          });
          // To get again user preferences and update in UI storage and user settings
          this.getUserDetails();
        },
        Error => {
          this.loading = false;
          console.error('ACH micro-deposit verify postPlaid error');
          console.error(Error);
          this.snackBar.open(Error.response.data, null, {
            extraClasses: ['error-snackbar'],
            duration: 5000
          });
        }
      );
    }
  }
  getUserDetails() {
    let userObjectSaved = this.localUser.getUser();
    this.userService.getUserPrefrence(userObjectSaved.id).subscribe(result => {
      userObjectSaved = this.userService.convertUserObjectToModel(result, userObjectSaved);
      localStorage.setItem('userDetails', JSON.stringify(userObjectSaved));
      this.closeMicrodepositVerifyDialog();
    });
  }
  closeMicrodepositVerifyDialog() {
    this.dialogRef.close(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/dialogs/ach-micro-deposit-verify/ach-micro-deposit-verify.component.ts